<template>
  <div id="noteManagerDiv" v-if="selectionStore.selectedNotesChords != null && selectionStore.selectedNotesChords.length > 0">
    <div>selected notes: {{ selectionStore.selectedNotesChordMap.size }}</div>
    <div>beat: {{ selectedNumerator }}/{{ selectedDenominator }}</div>
    <div style="display: flex; justify-content: space-between; width: 100%;">
      is long/freeze: <input type="checkbox" :checked="selectedLong" @click="setLong" />
    </div>
    <div id="noteParameterManagerDiv">
      <div v-for="[key, value] in Object.entries(selectedOther)" :key="key"
        style="display: flex; justify-content: space-between; width: 100%;">
        <button @click="removeParameterButtonClick(key)">x</button>
        {{ key }} :
        <input type="text" @input="e => setParameterValueButtonClick(key, e)" :value="value" />
      </div>
      <div>
        <input type="text" ref="newKeyTxtBox" />
        <button @click="addParameterButtonClick()">add key</button>
      </div>
    </div>
  </div>
  <div v-else>
    no note selected
  </div>
</template>

<script setup>
import { ref, useTemplateRef, defineProps, triggerRef, computed, inject } from 'vue';
import { useSelectionStore } from '../../stores/SelectionStore';

const selectionStore = useSelectionStore()
const mainChart = inject('mainChart')
const { notes } = mainChart

// details

const selectedNumerator = computed(() => {
  notes.value
  
  const noteIds = selectionStore.selectedNotesChordMap.keys()
  const firstId = selectionStore.selectedNotesChordMap.keys().next().value
  if(!firstId) return
  
  const t = notes.value.get(firstId).numerator
  if (noteIds.every(e => notes.value.get(e).numerator == t)) {
    return t
  }
  return '-'
})

const selectedDenominator = computed(() => {
  notes.value
  
  const noteIds = selectionStore.selectedNotesChordMap.keys()
  const firstId = selectionStore.selectedNotesChordMap.keys().next().value
  if(!firstId) return
  
  const t = notes.value.get(firstId).denominator
  if (noteIds.every(e => notes.value.get(e).denominator == t)) {
    return t
  }
  return '-'
})

const selectedOther = computed(() => {
  notes.value

  const res = {}
  const n = [...selectionStore.selectedNotesChordMap.keys().map(id => notes.value.get(id))]
  const allKeys = [...new Set(n.flatMap(obj => Object.keys(obj)))
    .difference(new Set(["noteId", "column", "eventLine", "numerator", "denominator", "beat"]))
  ];
  
  for (const key of allKeys) {
    if (n.every(e => e[key] == n[0][key]))
      res[key] = n[0][key]
    else
      res[key] = ""
  }
  return res
})

const selectedLong = computed(() => {
  notes.value
  
  const noteIds = selectionStore.selectedNotesChordMap.keys()
  const firstId = selectionStore.selectedNotesChordMap.keys().next().value
  if(!firstId) return
  
  const t = !!notes.value.get(firstId).long
  if (noteIds.every(e => !!notes.value.get(e).long == t)) {
    return t
  }
  return true
})

// actions

const newKeyTxtBox = useTemplateRef("newKeyTxtBox")
const addParameterButtonClick = () => {
  let key = newKeyTxtBox.value.value
  selectionStore.selectedNotesChordMap.keys().forEach(id => {
    mainChart.setNoteParameter(id, key, "")
  })
}

const removeParameterButtonClick = (key) => {
  selectionStore.selectedNotesChordMap.keys().forEach(id => {
    mainChart.setNoteParameter(id, key, null)
  })
}

const setParameterValueButtonClick = (key, e) => {
  selectionStore.selectedNotesChordMap.keys().forEach(id => {
    mainChart.setNoteParameter(id, key, e.target.value)
  })
}

const setLong = (e) => {
  selectionStore.selectedNotesChordMap.keys().forEach(id => {
    mainChart.setNoteParameter(id, "long", e.target.checked ? "x" : "")
  })
}

</script>

<style scoped>
#noteManagerDiv {
  display: block;
}

#noteManagerDiv option[active="true"] {
  background: rgb(255, 255, 255);
}

#noteSelect {
  min-width: 100px
}

#noteDetails {
  display: block;
}
</style>